<template>
  <div>
    <!--<v-alert type="error" v-if="error">{{ error }}</v-alert>-->
  </div>
</template>
<script>
import colors from 'vuetify/lib/util/colors';

import { mapState } from 'vuex';
export default {
  name: 'Authenticate',
  data() {
    return {
      error: ''
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.user,
      event: (state) => state.event
    })
  },
  async created() {
    await this.$store.dispatch('verifyToken');
    await this.initialize();
  },
  methods: {
    async initialize() {
      await this.$store.dispatch('userLogin');
      this.$vuetify.theme.themes.light.primary = colors[this.event.theme];
      this.$vuetify.theme.themes.dark.primary = colors[this.event.theme];
      // must connect to socket.io after session has been created.
      // to allow session to be available to socket
      this.status = 'waiting';
      this.connectToServer();
    },
    connectToServer() {
      this.$socket.client.open();
      this.$socket.client.emit('JOIN_VOTERS', this.user);
    }
  }
};
</script>
